import { ConfirmDialog } from "../../modal/ConfirmDialog";
import { useMemberProfile } from "../MemberProfileContext";

export function ActivateForm({ onClose }: { onClose: () => void }) {
    const { profile, activate, saving } = useMemberProfile();

    return (
        <ConfirmDialog
            open
            title="Activate member"
            description={`Are you sure you want to reactivate ${profile.memberName}?`}
            confirmLabel="Activate member"
            confirmDisabled={saving}
            onConfirm={() => {
                activate(onClose);
            }}
            onDismiss={onClose}
        />
    );
}
